import Meter from './Meter';
import Gain from './Gain';

export default class Manager {

    constructor() {
        window.AudioContext = window.AudioContext || window.webkitAudioContext;        
        
        this.meters = {};
        this.gains = {};
    }

    createContext() {        
        this.context = new window.AudioContext();
        this.destination = this.context.createMediaStreamDestination();
        if(this.context.state == 'suspended')
            return false;
        return true;
    }

    async init() {
        await this.context.audioWorklet.addModule('/worklet/audio-volume.js');
    }

    createMeter(id, track, callback) {
        if(track) {
            this.meters[id] = new Meter(this.context, this.destination, new MediaStream([track]), callback);
            return this.meters[id];        
        }
    }

    getMeter(id) {
        return this.meters[id];
    }

    stopMeter(id) {
        if(this.meters[id])
            this.meters[id].stop();
    }

    createGain(id, track) {
        this.gains[id] = new Gain(this.context, track);
        return this.gains[id]; 
    }

}